/*
 * @Author: kaker.xutianxing
 * @Date: 2019-09-02 16:51:20
 * @Last Modified by: kaker.xutianxing
 * @Last Modified time: 2019-11-27 10:29:44
 */
<template>
  <div class="x-notify" v-if="hasNeverActivateOrder">
    <p>
      当前账号在线下有购买产品/服务，需先激活才能正常使用，请尽快激活。
      <el-button type="danger" size="mini" @click="clickActive">去激活</el-button>
    </p>
    <!-- 未激活产品与服务 -->
    <el-dialog :visible.sync="activeProductDialog" :close-on-click-modal="false" width="640px" :append-to-body="true">
      <template slot="title">激活线下产品/服务</template>
      <p class="mt-20">您在线下有购买产品/服务，需先激活才能正常使用，请尽快激活；激活后，产品正式生效，开始计算产品服务时间；</p>
      <el-row style="padding-left: 15px;">
        <div v-for="(item, index) in activeList" :key="index" class="fl box mr-20 mt-20" :class="{activeBorder: !(item.isshow)}" @click="chooseActive(item)" v-if="categoryList.length>0">
          <img src="~@/assets/home/3333.png" alt="" class="fl">
          <div class="fl ml-10">
            <section class="p1">{{categoryList.filter(e=>{return e.ID===item.CategoryID})[0].Title}}</section>
            <section class="p2">{{item.PackageName}}</section>
          </div>
          <p class="check-icon"><span class="el-icon-check"></span></p>
        </div>
      </el-row>
      <span slot="footer">
        <el-button @click="activeProductDialog = false" size="small">下次再说</el-button>
        <el-button type="primary" size="small" @click="showAllactive">
          立即激活</el-button>
      </span>
    </el-dialog>
    <!-- 激活产品验证手机 -->
    <el-dialog title="验证手机" :visible.sync="idPhoneDialog" width="640px" :close-on-click-modal="false" @close="resetForm('idcardForm')" append-to-body class="footerDialog">
      <div style="padding-left: 50px;">
        <p>激活后，将开始计算产品服务时间，为确保您账号的安全性，需进行身份验证</p>
        <el-form @submit.native.prevent :model="idcardForm" :rules="rules" ref="idcardForm" class="mt-20" label-width="80px">
          <el-form-item label="手机号：">
            <span v-if="userPhone&&userPhone !== undefined">{{userPhone.substr(0,3)}}****{{userPhone.substr(-4)}}</span>
          </el-form-item>
          <el-form-item label="验证码：" prop="code">
            <el-input v-model="idcardForm.code" size="medium" :maxlength="5" style="width: 200px;"></el-input>
            <verification-button @send="SendMobileCode" :stop="secodeIdStop"></verification-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clickAllactive" style="width: 100px;" size="small">提交</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <div class="x-dialog" v-if="xMessageDialog">
      请勿频繁获取验证码，稍后再尝试（{{time}}s)
    </div>
  </div>
</template>

<script>
import { GetUserHasNeverActivateOrder, ActivateUserOrder, AllCategory, SendMobileCode, getAuthenticationStatus } from '@/api'
import VerificationButton from '@/components/verificationButton/'

export default {
  name: 'notify',
  components: {
    VerificationButton
  },
  data() {
    return {
      activeProductDialog: false,
      hasNeverActivateOrder: false,
      activeList: [],
      categoryList: [],
      idPhoneDialog: false, // 激活线下产品/服务手机dialog
      secodeIdStop: false,
      idcardForm: {
        phone: this.$store.state.user.staffInfo.phoneNumber,
        code: ''
      },
      rules: {
        code: [
          { validator: this.loginCodePass, required: true, trigger: 'blur' }
        ]
      },
      xMessageDialog: false,
      time: 5,
      clickPhoneLoginCode: false,
      phoneLoginCodeErrorInfo: ''
    }
  },
  computed: {
    userPhone() {
      return this.$store.state.user.staffInfo.accountType.code === 0
        ? this.$store.state.user.staffInfo.phoneNumber
        : this.$store.state.user.staffInfo.parentPhoneNumber;
    }
    // userPhone () {
    //   return this.$store.state.user.staffInfo.phoneNumber === '' ? this.$store.state.user.staffInfo.parentPhoneNumber : this.$store.state.user.staffInfo.phoneNumber
    // }
  },
  mounted() {
    this.GetUserHasNeverActivateOrder()
    this.AllCategory()
  },

  methods: {
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    loginCodePass(rule, value, callback) {
      if (this.clickPhoneLoginCode) {
        callback(new Error(this.phoneLoginCodeErrorInfo))
      } else {
        if (value === '') {
          callback(new Error('请输入验证码'))
        } else {
          callback()
        }
      }
    },
    showAllactive() {
      var checked = this.activeList.filter(item => {
        return !item.isshow
      })
      if (checked.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一个产品'
        })
        return
      }
      this.idPhoneDialog = true
    },
    chooseActive(val) {
      val.isshow = !val.isshow
    },
    SendMobileCode() {
      this.secodeIdStop = true
      SendMobileCode({})
        .then(res => {
          this.secodeIdStop = false
        })
        .catch(res => {
          this.secodeIdStop = true
          if (res.data.code === 210) {
            if (this.xMessageDialog) return
            this.xMessageDialog = true
            const timer = setInterval(() => {
              this.time--
              if (this.time === 0) {
                this.time = 5
                this.xMessageDialog = false
                clearInterval(timer)
              }
            }, 1000)
          }
        })
    },
    clickAllactive() {
      this.clickPhoneLoginCode = false
      var categoryID = null
      var checked = this.activeList.filter(item => {
        return !item.isshow
      })
      if (checked.length === 1) {
        categoryID = checked[0].CategoryID
      }
      this.$refs.idcardForm.validate(valid => {
        if (valid) {
          this.loading = this.$loading({
            background: 'rgba(225, 225, 225, 0.5)'
          })
          ActivateUserOrder({
            categoryID: categoryID,
            code: this.idcardForm.code
          })
            .then(res => {
              this.resetForm('idcardForm')
              this.clickPhoneLoginCode = false
              this.loading.close()
              this.hasNeverActivateOrder = false
              this.$message({
                message: '激活成功！',
                type: 'success'
              })
              this.activeProductDialog = false
              this.idPhoneDialog = false
              this.GetUserHasNeverActivateOrder()
              const index = this.$parent.$children.findIndex(x => x.hasOwnProperty('TTLoading'))
              if (index > -1) {
                this.$parent.$children[index].CheckTTService()
              }
            })
            .catch(e => {
              this.loading.close()
              if (e.data.code === 210) {
                // 验证码有问题
                this.clickPhoneLoginCode = true
                this.phoneLoginCodeErrorInfo = e.data.message
                this.$refs.idcardForm.validateField('code')
              }
            })
        }
      })
    },
    clickActive() {
      this.activeProductDialog = true
    },
    GetUserHasNeverActivateOrder() {
      GetUserHasNeverActivateOrder({}).then(res => {
        this.hasNeverActivateOrder = res.data.length > 0
        this.activeList = res.data
        this.activeList.forEach(element => {
          this.$set(element, 'isshow', false)
        })
        if (res.data.length === 0) {
          this.getAuthenticationStatus()
        }
      })
    },
    AllCategory() {
      const data = {}
      AllCategory(data)
        .then(res => {
          this.categoryList = res.data
        })
    },
    getAuthenticationStatus() {
      getAuthenticationStatus()
        .then(res => {
          this.$store.commit('SETSTAFFAUTHENTICATIONSTATUS', res.data)
        })
    }
  }
}

</script>
<style lang='scss' scoped>
.box {
  width: 180px;
  height: 100px;
  border: 1px solid #d0d0d0;
  padding: 30px 10px;
  cursor: pointer;
  text-align: left;
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  &:nth-of-type(3n) {
    margin-right: 0;
  }
  .p1 {
    font-weight: 700;
  }
  .p2 {
    font-size: 12px;
  }
  .check-icon {
    height: 25px;
    background-color: #c6e2ff;
    color: #fff;
    position: absolute;
    right: -17px;
    top: -5px;
    width: 50px;
    text-align: center;
    transform: rotate(45deg);
    line-height: 32px;
    .el-icon-check {
      font-size: 15px;
      transform: rotate(-45deg);
    }
  }
}
.activeBorder {
  border-color: #409eff;
  .check-icon {
    background-color: #409eff;
  }
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #555;
  padding: 0 30px;
  .el-icon-warning {
    color: #e6a23c;
    font-size: 20px;
    margin-right: 10px;
    margin-top: 5px;
  }
}
/deep/ .el-dialog__header {
  font-size: 18px;
}
.x-dialog {
  min-width: 380px;
  box-sizing: border-box;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: #ebeef5;
  position: fixed;
  left: 50%;
  top: 20px;
  transform: translateX(-50%);
  background-color: #edf2fc;
  transition: opacity 0.3s, -webkit-transform 0.4s;
  transition: opacity 0.3s, transform 0.4s;
  transition: opacity 0.3s, transform 0.4s, -webkit-transform 0.4s;
  overflow: hidden;
  padding: 15px 15px 15px 20px;
  display: flex;
  align-items: center;
  z-index: 3000;
  color: #999;
}
</style>
